export const SET_LOCK_PAYMENT_INPUTS_IN_SV = 'SET_LOCK_PAYMENT_INPUTS_IN_SV';
export const LOCK_PAYMENT_INPUTS_CLICKED = 'LOCK_PAYMENT_INPUTS_CLICKED';
